export const eligibilityWY = {
  statusButtons: {
    healthcare: 'Go to the marketplace',
    offExchange: 'Shop directly with BCBSWY',
    close: 'Close',
    ffmSSO: 'Go to the marketplace',
    highmarkDirect: 'FIND A STORE',
    backBtn: 'BACK'
  },
  MultiTaxHousehold: {
    id: 'MultiTaxHousehold',
    icon: true,
    messageTitle:
      'The group of individuals submitted for coverage consideration may not be covered under the same policy.',
    messageContent:
      'The Health Insurance Marketplace indicates that there are multiple  tax households in this applicant group. We cannot currently process multiple tax households on the same policy. However, there are still options to buy health insurance. Members of this group can enroll in different plans by returning to the Health Insurance Marketplace. Coverage can be purchased directly from BCBSWY, or by shopping at Healthcare.gov. Plans purchased directly from BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) or Cost-Sharing Reduction (CSR).',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    buttons: {
      healthcare: true,
      offExchange: true,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  unsupportedFam: {
    id: 'unsupportedFam',
    icon: true,
    messageTitle:
      'This application requires additional action. Please determine which option best describes your group before you select an option.',
    messageContent:
      'The group of individuals submitted for coverage consideration may not be covered under the same policy. However, there are still options to buy health insurance. Members of this group can enroll in different plans by returning to the Health Insurance Marketplace at healthcare.gov. Or, coverage can be purchased directly from BCBSWY. Plans purchased directly from BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) or Cost-Sharing Reduction (CSR).',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    CSR:
      'This applicant(s) is eligible for a Cost-Sharing Reduction (CSR).  A Cost-Sharing Reduction (CSR) reduces out-of-pocket costs on certain qualified health plans.',
    APTC:
      'This applicant(s) is eligible for an Advanced Premium Tax Credit (APTC) that can be applied towards the monthly premium costs of any individual, metal level qualified health plan.',
    BothCases: 'Below, we\'ll show you what this means for the plans available.',
    extraMessage: 'You can view the eligibility information below.',
    buttons: {
      healthcare: true,
      offExchange: true,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  SEPfamily: {
    id: 'SEPfamily',
    icon: true,
    messageTitle:
      'Welcome back! This application has qualified for a Special Enrollment Period (SEP) which cannot be processed through this system.  Log back into the Marketplace and then select "See my coverage options, Step 3" and then "Continue to Enrollment" to view available plans.',
    messageContent: 'Customers can call BSBWY for assistance',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    CSR:
      'This applicant(s) is eligible for a Cost-Sharing Reduction (CSR).  A Cost-Sharing Reduction (CSR) reduces out-of-pocket costs on certain qualified health plans.',
    APTC:
      'This applicant(s) is eligible for an Advanced Premium Tax Credit (APTC) that can be applied towards the monthly premium costs of any individual, metal level qualified health plan.',
    BothCases: 'Below, we\'ll show you what this means for the plans available.',
    extraMessage: 'You can view the eligibility information below.',
    buttons: {
      healthcare: true,
      offExchange: true,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  incompleteApp: {
    id: 'incompleteApp',
    icon: true,
    messageTitle:
      'Welcome back! It looks like you were unable to complete the application you started on the Health Insurance Marketplace.',
    messageContent:
      'Return to the Marketplace and complete the information, or shop directly with BCBSWY.  Plans purchased directly from BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) or Cost-Sharing Reduction (CSR).',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    buttons: {
      healthcare: false,
      offExchange: true,
      close: true,
      ffmSSO: true,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  inconsistentBrandProdcuer: {
    id: 'inconsistentBrandProdcuer',
    icon: true,
    brandViolation: true,
    messageTitle:
      'Welcome back! It looks like you were unable to complete the application you started on the Health Insurance Marketplace.',
    messageContent:
      '<p><b>The applicant\'s Zip code and your current agency/region do not match.</b></p> <br> Please note the following Contact Person information, to help you find the application on the Health Insurance Marketplace.',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    extraMessage:
      'Close this message and return to your Account Settings to update your agency/region to match the applicant Zip code.',
    coverageYear: '2017',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  inconsistentBrandConsumer: {
    id: 'inconsistentBrandConsumer',
    icon: true,
    brandViolation: true,
    messageTitle:
      '<p><b>Coverage State and Marketplace Enrollment State Mismatch.</b></p>',
    messageContent:
      '<p>The registration coverage state and the state you have chosen for the Marketplace enrollment do not match.</p><br> <p>Talk to an agent by calling:</p> <br><p>Monday - Friday:  8 AM - 5 PM </p><br><p>800-851-2227</p><br><p>TTY: 711, TDD: 800-696-4710</p> <p>If you have a technical question about this website, please call 1-800-294-9568.</p>',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    extraMessage: '',
    consumer: true,
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false,
      backBtn: true
    }
  },
  eligibilityException: {
    id: 'eligibilityException',
    icon: true,
    messageTitle:
      'Welcome back! It looks like there were some problems with the Health Insurance Marketplace application you submitted.',
    messageContent:
      'Return to the Marketplace and complete the information, or shop directly with BCBSWY.  Plans purchased directly from BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) or Cost-Sharing Reduction (CSR).',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    buttons: {
      healthcare: false,
      offExchange: true,
      close: true,
      ffmSSO: true,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  QHPIneligible: {
    id: 'QHPIneligible',
    icon: false,
    messageTitle:
      'These applicants do not qualify for a qualified health plan (QHP).',
    messageContent:
      'Based on the information provided to the Health Insurance Marketplace, this applicant(s) does not currently qualify for a QHP.',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: true,
      highmarkDirect: false
    }
  },
  QHPEligible: {
    id: 'QHPEligible',
    icon: false,
    messageTitle:
      'The applicant(s) below is/are eligible to purchase a qualified health plan (QHP).',
    messageContent: '',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    CSR:
      'This applicant(s) is eligible for a Cost-Sharing Reduction (CSR).  A Cost-Sharing Reduction (CSR) reduces out-of-pocket costs on certain qualified health plans.',
    APTC:
      'This applicant(s) is eligible for an Advanced Premium Tax Credit (APTC) that can be applied towards the monthly premium costs of any individual, metal level qualified health plan.',
    BothCases: 'Below, we\'ll show you what this means for the plans available.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  errorApp: {
    id: 'errorApp',
    icon: true,
    messageTitle:
      'Welcome back!  It looks like there were some problems with the Health Insurance Marketplace application you submitted.',
    messageContent: 'A system error has occurred.  Please resume application.',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  contingency: {
    id: 'contingency',
    icon: true,
    messageTitle: 'Plans for this service area are temporarily unavailable.',
    messageContent:
      '<p>BCBSWY is presently updating its coverage options for this region.  Please check back with us soon.</p><br /><p>Need help? </p> <br><p>Monday - Friday:  8 AM - 5 PM </p><br><p>800-851-2227</p><br><p>TTY: 711, TDD: 800-696-4710</p> <p>If you have a technical question about this website, please call 1-800-294-9568.</p>',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: true
    }
  },
  errorAppDP: {
    id: 'errorAppDP',
    icon: true,
    messageTitle: '',
    messageContent:
      'There has been a problem transitioning from CMS to the Partner website. We recommend trying again by going to Application Status and retrieving the applicants application and returning to the Partner site again. This generally resolves a second time. <br><strong><a href="/individual/new-business/on-exchange/application-status">RETURN TO APPLICATION STATUS</a></strong><br>If this continues, please contact us.<br /><p> </p>To report a technical issue, please contact technical support: <br/> Monday - Friday <br/> 8 a.m. - 5 p.m. <br/> 800-851-2227 <br/> TTY: 711, TDD: 800-696-4710.',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  over25: {
    id: 'over25',
    icon: true,
    messageTitle:
      'The group of individuals submitted for coverage consideration may not be covered under the same policy.',
    messageContent:
      'One of the applicants cannot be covered as a dependent on his/her parent\'s plan for the selected coverage start date.  Coverage for adult children must begin before  age 26. This applicant can apply for individual coverage directly from BCBSWY, or shop at Healthcare.gov. Plans purchased directly from BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) or Cost-Sharing Reduction (CSR).',
    QSEHRAorICHRA:
      'Based on the information you provided, you are eligible for an ICHRA (Individual Coverage Health Reimbursement Arrangement), please go to the Marketplace to complete your enrollment.'
  },
  content: {
    APTC: {
      messageTitle: 'A lower premium',
      messageSubtext: 'APTC',
      messageContent:
        'This is an Advanced Premium Tax Credit (APTC) that can be used right away, or saved for later. The tax credit can be used to lower the monthly premium cost of an individual, metal level qualified health plan.  The applicant(s) can choose how much of the credit to apply toward the monthly premium.',
      messageContentConsumer:
        'Important: The Tax Filer(s) must make the premium tax credit attestation, located at the end of this enrollment process, in order to receive the Advanced Premium Tax Credit (APTC).'
    },
    CSR: {
      messageTitle: 'A Cost-Sharing Reduction (CSR)',
      messageSubtext: 'CSR',
      messageContent:
        'Cost-Sharing Reductions (CSRs) can be used to lower out-of-pocket costs <span class=\'silverHighlights\'>on individual Silver level qualified health plans only</span>. American Indian/ Alaska Native Cost-Sharing Reductions (CSRs) are available for all individual, metal level qualified health plans.',
      youQualify: 'You qualify!'
    },
    primary: {
      messageTitle: 'Primary Applicant',
      messageContent:
        'If the Primary Applicant is incorrect or if you wish to select a different Primary Applicant, please return to the Marketplace. The Primary Applicant cannot be a dependent on the plan.',
      iconShowup: true,
      iconPopup:
        'The primary applicant is the individual who is subscribing to this plan. If you are applying for coverage on behalf of your dependent(s), you are considered the primary applicant.'
    },
    startDate: {
      messageTitle: 'Coverage Start Date',
      messageContent:
        'Please select the date coverage should start. The following date was provided by the Health Insurance Marketplace and may differ from information provided earlier on BCBSWY\'s site.  If this information is incorrect, please return to the Marketplace to edit the information.'
    },
    viewEligibility: {
      messageTitle: 'You can view the eligibility information below.',
      messageContent:
        'You\'re eligible for a tax credit which can be applied towards your premium, and a cost sharing reduction which reduces how much you have to spend on your health care. Below, we\'ll show you what this means for the plans you\'ve selected.'
    },
    medicaid: {
      PA: 'https://www.compass.state.pa.us/compass.web/CMHOM.aspx',
      DE: 'https://assist.dhss.delaware.gov/',
      WV: 'https://www.wvinroads.org/selfservice/'
    },
    CHIP: {
      PA:
        'https://www.discoverhighmark.com/individuals-families/insurance/children',
      DE:
        'https://www.discoverhighmark.com/individuals-families/insurance/children',
      WV: 'https://www.wvinroads.org/selfservice/'
    },
    eligibilityTitle: {
      preMessage:
        'The information below was provided by the Health Insurance Marketplace and may differ from the information you submitted on the Marketplace website and/or the information provided  earlier on BCBSWY\'s website. The below information will be used going forward.  If any of the information below is incorrect or has changed, ',
      link: 'please return to the Marketplace',
      postMessage:
        ' to edit the information. Any incorrect information may result in the application being denied and/or the primary applicant and his or her dependents health care coverage being cancelled.'
    },
    extraMessage: {
      firstPara:
        'Applicants in this group qualify for different Cost-Sharing Reductions (CSRs).  However, this website does not support multiple enrollment groups, so please select one of these options:',
      secondPara:
        'This applicant group may enroll in the most generous Cost-Sharing Reduction (CSR) plan for which all members of this group are eligible. ',
      thirdPara:
        'Alternatively, members of this applicant group can enroll in different plans to take advantage of their respective cost-sharing reductions.  Members of this group can enroll in different plans by returning to the Health Insurance Marketplace.',
      extraHeadline:
        'The following individuals either qualify for Medicaid and/or CHIP or they do not qualify for a qualified health plan at this time.'
    },
    familyInfoTitle: 'Family Information',
    tobaccoIconShowup: true,
    tobaccoPopup:
      'Have you smoked or used any form of tobacco regularly (4 or more times per week on average excluding religious or ceremonial use) within the last six months?',
    familyInfoDetail: {
      lineOne: 'This applicant is QHP eligible',
      lineTwoPre: 'This applicant is eligible for ',
      lineTwoPost: ' per month of Advanced Premium Tax Credit (APTC)',
      lineThree:
        'This applicant is eligible to purchase a Cost-Sharing Reduction (CSR) plan variation'
    },
    links: {
      returnHealthcareGov: 'Return to Healthcare.gov',
      qualifyCHIP: 'Qualifies for CHIP',
      qualifyMedicaid: 'Qualifies for Medicaid'
    }
  },
  leftNav: {
    id: 'marketplace-sidebar',
    sidebarLoadedId: 'marketplace-sidebar-Loaded',
    desktopHeadlineText: 'REVIEW ELIGIBILITY APPLICATION RESULTS',
    sectionTitle: 'REVIEW ELIGIBILITY APPLICATION RESULTS',
    sectionHomeHref: '#!/marketplace/eligibility',
    subText:
      'View a summary of eligibility for qualified health plans and the next steps to take.',
    forceReload: true,
    mobileOnly: false,
    links: [
      {
        linkId: 'eligibility-sbLink',
        linkHref: '#!/marketplace/eligibility',
        linkTitle: 'Shop For Plans',
        linkText: 'Shop For Plans'
      }
    ]
  }
};

export const eligibilityND = {
  statusButtons: {
    healthcare: 'Go to the marketplace',
    offExchange: 'Shop directly with BCBSND',
    close: 'Close',
    ffmSSO: 'Go to the marketplace',
    highmarkDirect: 'FIND A STORE',
    newQuote: 'New Quote',
    backBtn: 'BACK'
  },
  MultiTaxHousehold: {
    id: 'MultiTaxHousehold',
    icon: true,
    messageTitle: 'The group of individuals submitted for coverage consideration may not be covered under the same policy.',
    messageContent: 'The Health Insurance Marketplace indicates that there are multiple tax households in this applicant group. We cannot currently process multiple tax households on the same policy. However, there are still options to buy health insurance. Individuals of this group can enroll in different plans by returning to the Health Insurance Marketplace. Coverage can be purchased directly from Blue Cross Blue Shield of North Dakota (BCBSND), or by shopping at Healthcare.gov. Plans purchased directly from BCBSND are not eligible for the advance premium tax credit (APTC) or cost-sharing reduction (CSR).',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    buttons: {
      healthcare: true,
      offExchange: true,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  unsupportedFam: {
    id: 'unsupportedFam',
    icon: true,
    messageTitle: 'This application requires additional action. Please determine which option best describes your group before you select an option.',
    messageContent: 'If you have several individuals submitted for coverage consideration, they may not be covered under the same insurance policy. However, there are still options to buy health insurance. Each individual can enroll in different plans by returning to the Health Insurance Marketplace. Coverage can be purchased directly from BCBSND, or by shopping at Healthcare.gov. Plans purchased directly from BCBSND are not eligible for the advance premium tax credit (APTC) or cost-sharing reduction (CSR).',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    CSR: 'This applicant(s) is eligible for a Cost-Sharing Reduction (CSR).  A Cost-Sharing Reduction (CSR) reduces out-of-pocket costs on certain qualified health plans.',
    APTC: 'This applicant(s) is eligible for an Advanced Premium Tax Credit (APTC) that can be applied towards the monthly premium costs of any individual, metal level qualified health plan.',
    BothCases: 'Below, we\'ll show you what this means for the plans available.',
    extraMessage: 'You can view the eligibility information below.',
    buttons: {
      healthcare: true,
      offExchange: true,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  SEPfamily: {
    id: 'SEPfamily',
    icon: true,
    messageTitle: 'Welcome back! This application has qualified for a Special Enrollment Period (SEP) which cannot be processed through this system.  Log back into the Marketplace and then select "See my coverage options, Step 3" and then "Continue to Enrollment" to view available plans.',
    messageContent: 'Customers can call BCBSND for assistance<br /><br />800-280-2583<br>Monday-Friday<br> 8 a.m. - 4 p.m. CST<br />(TTY/TDD: 711) <br />Agents can call Producer Hotline or their BCBSND representative.<br />Additionally, this application can be completed by contacting a Health Insurance Marketplace representative:<br />Call 800-280-2583<br>Monday-Friday<br> 8 a.m. - 4 p.m. CST<br />(TTY/TDD: 711)',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    CSR: 'This applicant(s) is eligible for a Cost-Sharing Reduction (CSR).  A Cost-Sharing Reduction (CSR) reduces out-of-pocket costs on certain qualified health plans.',
    APTC: 'This applicant(s) is eligible for an Advanced Premium Tax Credit (APTC) that can be applied towards the monthly premium costs of any individual, metal level qualified health plan.',
    BothCases: 'Below, we\'ll show you what this means for the plans available.',
    extraMessage: 'You can view the eligibility information below.',
    buttons: {
      healthcare: true,
      offExchange: true,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  incompleteApp: {
    id: 'incompleteApp',
    icon: true,
    messageTitle: 'Welcome back! It looks like you were unable to complete the application you started on the Health Insurance Marketplace.',
    messageContent: 'Return to the Marketplace and complete the information, or shop directly with Blue Cross Blue Shield of North Dakota (BCBSND). Plans purchased directly from BCBSND are not eligible for the advance premium tax credit (APTC) or cost-sharing reduction (CSR).',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    buttons: {
      healthcare: false,
      offExchange: true,
      close: true,
      ffmSSO: true,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  inconsistentBrandProdcuer: {
    id: 'inconsistentBrandProdcuer',
    icon: true,
    brandViolation: true,
    messageTitle: 'Welcome back! It looks like you were unable to complete the application you started on the Health Insurance Marketplace.',
    messageContent: '<p><b>The applicant\'s Zip code and your current agency/region do not match.</b></p> <br> Please note the following Contact Person information, to help you find the application on the Health Insurance Marketplace.',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    extraMessage: 'Close this message and return to your Account Settings to update your agency/region to match the applicant Zip code.',
    coverageYear: '2017',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  inconsistentBrandConsumer: {
    id: 'inconsistentBrandConsumer',
    icon: true,
    brandViolation: true,
    messageTitle: '<p><b>Coverage State and Marketplace Enrollment State Mismatch.</b></p>',
    messageContent: '<p>The registration coverage state and the state you have chosen for the Marketplace enrollment do not match.</p><br> <p>Need help?  Contact Us.<br>800-280-2583<br>Monday - Friday:  8 a.m. - 4:30 p.m. CST<br><br>(TTY/TDD: 711)</p>',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    extraMessage: '',
    consumer: true,
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false,
      backBtn: true
    }
  },
  eligibilityException: {
    id: 'eligibilityException',
    icon: true,
    messageTitle: 'Welcome back! It looks like there were some problems with the Health Insurance Marketplace application you submitted.',
    messageContent: 'Return to the Marketplace and complete the information, or shop directly with Blue Cross Blue Shield of North Dakota (BCBSND). Plans purchased directly from BCBSND are not eligible for the advance premium tax credit (APTC) or cost-sharing reduction (CSR).',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    buttons: {
      healthcare: false,
      offExchange: true,
      close: true,
      ffmSSO: true,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  QHPIneligible: {
    id: 'QHPIneligible',
    icon: false,
    messageTitle: 'These applicants do not qualify for a qualified health plan (QHP).',
    messageContent: 'Based on the information provided to the Health Insurance Marketplace, this applicant(s) does not currently qualify for a QHP.',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: true,
      highmarkDirect: false
    }
  },
  QHPEligible: {
    id: 'QHPEligible',
    icon: false,
    messageTitle: 'The applicant(s) below is/are eligible to purchase a qualified health plan (QHP).',
    messageContent: '',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    CSR: 'This applicant(s) is eligible for a Cost-Sharing Reduction (CSR).  A Cost-Sharing Reduction (CSR) reduces out-of-pocket costs on certain qualified health plans.',
    APTC: 'This applicant(s) is eligible for an Advanced Premium Tax Credit (APTC) that can be applied towards the monthly premium costs of any individual, metal level qualified health plan.',
    BothCases: 'Below, we\'ll show you what this means for the plans available.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  errorApp: {
    id: 'errorApp',
    icon: true,
    messageTitle: 'Plans for this service area are temporarily unavailable online.',
    messageContent: 'We\'re sorry for the inconvenience. Blue Cross Blue Shield of North Dakota is available to help with your coverage needs offline. Or, you can try again later.<p>Need help?  Give us a call.<br><br>800-280-2583<br>Monday - Friday<br>(8 a.m. - 4:30 p.m. CST)<br>(TTY/TDD: 711)</p><p>Prefer face-to-face help?<br>Stop by a <a href=\'https://www.bcbsnd.com/about/company/office-locations\' target=\'_blank\'>BCBSND location</a> near you or <a href=\'https://www.bcbsnd.com/web/guest/find-an-agent\' target=\'_blank\'>find an agent</a>. Speak with one of our experienced agents for guided help choosing a plan that is right for you.</p>',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  contingency: {
    id: 'contingency',
    icon: true,
    messageTitle: 'Plans for this service area are temporarily unavailable.',
    messageContent: 'We\'re sorry for the inconvenience. Blue Cross Blue Shield of North Dakota is available to help with your coverage needs offline. Or, you can try again later.<p>Need help?  Give us a call.<br><br>800-280-2583<br>Monday - Friday<br>(8 a.m. - 4:30 p.m. CST)<br>(TTY/TDD: 711)</p><p>Prefer face-to-face help?<br>Stop by a <a href=\'https://www.bcbsnd.com/about/company/office-locations\' target=\'_blank\'>BCBSND location</a> near you or <a href=\'https://www.bcbsnd.com/web/guest/find-an-agent\' target=\'_blank\'>find an agent</a>. Speak with one of our experienced agents for guided help choosing a plan that is right for you.</p>',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: false,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: true
    }
  },
  errorAppDP: {
    id: 'errorAppDP',
    icon: true,
    messageTitle: '',
    messageContent: 'There has been a problem accessing this service.<br /><p>Need help?  Contact Us.<br>800-280-2583<br>Monday - Friday:  8 a.m. - 4:30 p.m. CST<br><br>(TTY/TDD: 711)</p>',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.',
    buttons: {
      healthcare: false,
      offExchange: false,
      close: true,
      ffmSSO: false,
      bottomClose: false,
      highmarkDirect: false
    }
  },
  over25: {
    id: 'over25',
    icon: true,
    messageTitle: 'All health plans are for individual coverage. If you are looking to cover multiple individuals, you will need to consider a separate policy for each person.',
    messageContent: 'One of the applicants cannot be covered as a dependent on his/her parent\'s plan for the selected coverage start date.  Coverage for adult children must begin before  age 26. This applicant can apply for individual coverage directly from BCBSND, or shop at Healthcare.gov. Plans purchased directly from BCBSND are not eligible for the Advanced Premium Tax Credit (APTC) or Cost-Sharing Reduction (CSR).',
    QSEHRAorICHRA: 'This is content for the QSEHRA or ICHRA stuff, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur efficitur feugiat enim eu dignissim. Etiam eget ultricies nibh. Praesent eros nisl, egestas ac ultrices sed, dapibus vel ligula. Suspendisse potenti. Vivamus ut efficitur ante. Duis rhoncus volutpat pharetra. Nulla pellentesque mattis facilisis. Vestibulum nec massa eu risus lacinia.'
  },
  content: {
    APTC: {
      messageTitle: 'A lower premium',
      messageSubtext: 'APTC',
      messageContent: 'This is an advance premium tax credit (APTC) that can be used right away, or saved for later. The tax credit can be used to lower the monthly premium cost of an individual, metal level qualified health plan.  The applicant(s) can choose how much of the credit to apply toward the monthly premium.',
      messageContentConsumer: 'Important: The Tax Filer(s) must provide the premium tax credit attestation, located at the end of this enrollment process, in order to receive the advance premium tax credit (APTC).'
    },
    CSR: {
      messageTitle: 'A Cost-Sharing Reduction (CSR)',
      messageSubtext: 'CSR',
      messageContent: 'Cost-Sharing Reductions (CSRs) can be used to lower out-of-pocket costs <span class=\'silverHighlights\'>on individual Silver level qualified health plans only</span>. American Indian/ Alaska Native CSRs are available for all individual, metal level qualified health plans.',
      youQualify: 'You qualify!'
    },
    primary: {
      messageTitle: 'Primary Applicant',
      messageContent: 'If the Primary Applicant is incorrect or if you wish to select a different Primary Applicant, please return to the Marketplace. The Primary Applicant cannot be a dependent on the plan.',
      iconShowup: true,
      iconPopup: 'The primary applicant is the individual who is subscribing to this plan. He/She must be atleast 18 years of age.'
    },
    startDate: {
      messageTitle: 'Coverage Start Date',
      messageContent: 'Please select the date coverage should start. The following date was provided by the Health Insurance Marketplace and may differ from information provided earlier on Blue Cross Blue Shield of North Dakota  website.  If this information is incorrect, please return to the Marketplace to edit the information.'
    },
    viewEligibility: {
      messageTitle: 'You can view the eligibility information below.',
      messageContent: 'You\'re eligible for a tax credit which can be applied towards your premium, and a cost sharing reduction which reduces how much you have to spend on your health care. Below, we\'ll show you what this means for the plans you\'ve selected.'
    },
    medicaid: {
      PA: 'https://www.compass.state.pa.us/compass.web/CMHOM.aspx',
      DE: 'https://assist.dhss.delaware.gov/',
      WV: 'https://www.wvinroads.org/selfservice/'
    },
    CHIP: {
      PA: 'https://www.discoverhighmark.com/individuals-families/insurance/children',
      DE: 'https://www.discoverhighmark.com/individuals-families/insurance/children',
      WV: 'https://www.wvinroads.org/selfservice/'
    },
    eligibilityTitle: {
      preMessage: 'The information below was provided by the Health Insurance Marketplace and may differ from the information you submitted on the Marketplace website and/or the information provided earlier on Blue Cross Blue Shield of North Dakota\'s website. The  information below will be used going forward.  If any of the information below is incorrect or has changed, ',
      link: 'please return to the Marketplace',
      postMessage: ' to edit the information. Any incorrect information may result in the application being denied and/or the primary applicant and his or her dependents health care coverage being cancelled.'
    },
    extraMessage: {
      firstPara: 'Applicants in this group qualify for different Cost-Sharing Reductions (CSRs).  However, this website does not support multiple enrollment groups, so please select one of these options:',
      secondPara: 'This applicant group may enroll in the most generous Cost-Sharing Reduction (CSR) plan for which all members of this group are eligible. ',
      thirdPara: 'Alternatively, members of this applicant group can enroll in different plans to take advantage of their respective cost-sharing reductions.  Members of this group can enroll in different plans by returning to the Health Insurance Marketplace.',
      extraHeadline: 'The following individuals either qualify for Medicaid and/or CHIP or they do not qualify for a qualified health plan at this time.'
    },
    familyInfoTitle: 'Family Information',
    tobaccoIconShowup: true,
    tobaccoPopup: 'Have you smoked or used any form of tobacco regularly (4 or more times per week on average excluding religious or ceremonial use) within the last six months?',
    familyInfoDetail: {
      lineOne: 'This applicant is QHP eligible',
      lineTwoPre: 'This applicant is eligible for ',
      lineTwoPost: ' per month of Advanced Premium Tax Credit (APTC)',
      lineThree: 'This applicant is eligible to purchase a Cost-Sharing Reduction (CSR) plan variation'
    },
    links: {
      returnHealthcareGov: 'Return to Healthcare.gov',
      qualifyCHIP: 'Qualifies for CHIP',
      qualifyMedicaid: 'Qualifies for Medicaid'
    }
  },
  leftNav: {
    id: 'marketplace-sidebar',
    sidebarLoadedId: 'marketplace-sidebar-Loaded',
    desktopHeadlineText: 'REVIEW ELIGIBILITY APPLICATION RESULTS',
    sectionTitle: 'REVIEW ELIGIBILITY APPLICATION RESULTS',
    sectionHomeHref: '#!/marketplace/eligibility',
    subText: 'View a summary of eligibility for qualified health plans and the next steps to take.',
    forceReload: true,
    mobileOnly: false,
    links: [{
      linkId: 'eligibility-sbLink',
      linkHref: '#!/marketplace/eligibility',
      linkTitle: 'Shop For Plans',
      linkText: 'Shop For Plans'
    }]
  }
}
